/* Handles the interaction between card grid and carousel slides */

class ExpandedCardCarousel {
  constructor(container) {
    this.container = container;
    this.cardsWrapper = container.querySelector('[data-cards-wrapper]');
    this.sliderWrapper = container.querySelector('[data-slider-wrapper]');
    this.cards = container.querySelectorAll('.expanded-card-carousel__card');
    this.slides = container.querySelectorAll('.expanded-card-carousel__slide');
    this.closeButton = container.querySelector('[data-carousel-close]');
    this.prevButton = container.querySelector('.carousel__button--prev');
    this.nextButton = container.querySelector('.carousel__button--next');

    this.currentSlideIndex = 0;
    this.isCarouselOpen = false;

    this.init();
  }

  init() {
    if (!this.cardsWrapper || !this.sliderWrapper) {
      console.warn('ExpandedCardCarousel: Missing required elements');
      return;
    }

    this.attachEventListeners();
  }

  attachEventListeners() {
    this.cards.forEach((card) => {
      card.addEventListener('click', (e) => {
        const index = parseInt(card.dataset.cardIndex, 10);
        this.openCarousel(index);
      });
    });

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.closeCarousel();
      });
    }

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.goToPrevSlide();
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.goToNextSlide();
      });
    }

    document.addEventListener('keydown', (e) => {
      if (!this.isCarouselOpen) return;

      switch (e.key) {
        case 'Escape':
          this.closeCarousel();
          break;
        case 'ArrowLeft':
          this.goToPrevSlide();
          break;
        case 'ArrowRight':
          this.goToNextSlide();
          break;
      }
    });

    // Add swipe support for the slider
    this.initSwipeSupport();
  }

  initSwipeSupport() {
    if (typeof SwipeHandler === 'undefined' || !this.sliderWrapper) return;

    this.swipeHandler = new SwipeHandler(this.sliderWrapper, {
      onSwipeLeft: () => {
        if (this.isCarouselOpen) {
          this.goToNextSlide();
        }
      },
      onSwipeRight: () => {
        if (this.isCarouselOpen) {
          this.goToPrevSlide();
        }
      },
      threshold: 50,
      restraint: 100,
      allowedTime: 500,
    });
  }

  openCarousel(slideIndex) {
    this.currentSlideIndex = slideIndex;
    this.isCarouselOpen = true;

    this.cardsWrapper.classList.add('is-sliding-out');

    setTimeout(() => {
      this.cardsWrapper.style.display = 'none';
      this.cardsWrapper.classList.remove('is-sliding-out');

      this.sliderWrapper.style.display = 'block';
      this.sliderWrapper.classList.add('is-sliding-in');

      this.goToSlide(slideIndex);

      const slideHeading = this.slides[slideIndex].querySelector('.expanded-card-carousel__slide-heading');
      requestAnimationFrame(() => slideHeading?.focus());

      setTimeout(() => {
        this.sliderWrapper.classList.remove('is-sliding-in');
      }, 400);
    }, 400);

    //document.body.style.overflow = 'hidden';
    //
  }

  closeCarousel() {
    this.isCarouselOpen = false;

    this.sliderWrapper.classList.add('is-sliding-out');

    setTimeout(() => {
      this.sliderWrapper.style.display = 'none';
      this.sliderWrapper.classList.remove('is-sliding-out');

      this.cardsWrapper.style.display = 'block';
      this.cardsWrapper.classList.add('is-sliding-in');

      setTimeout(() => {
        this.cardsWrapper.classList.remove('is-sliding-in');
      }, 400);
      const openerCard = [...this.cards].find(card => card.dataset.cardIndex == this.currentSlideIndex);
      console.log(openerCard);
      openerCard.focus();
    }, 400);

    //document.body.style.overflow = '';
  }

  goToSlide(index) {
    this.slides.forEach((slide) => {
      slide.classList.remove('is-active');
    });

    if (this.slides[index]) {
      this.slides[index].classList.add('is-active');
      this.currentSlideIndex = index;
    }

    this.updateNavButtons();

    this.announceSlide(index);
  }

  goToPrevSlide() {
    const newIndex = this.currentSlideIndex === 0 ? this.slides.length - 1 : this.currentSlideIndex - 1;

    this.goToSlide(newIndex);
  }

  goToNextSlide() {
    const newIndex = this.currentSlideIndex === this.slides.length - 1 ? 0 : this.currentSlideIndex + 1;

    this.goToSlide(newIndex);
  }

  updateNavButtons() {
    const isFirst = this.currentSlideIndex === 0;
    const isLast = this.currentSlideIndex === this.slides.length - 1;

    if (this.prevButton) {
      const prevIndex = isFirst ? this.slides.length - 1 : this.currentSlideIndex - 1;
      this.prevButton.setAttribute('aria-label', `Previous slide (${prevIndex + 1} of ${this.slides.length})`);
    }

    if (this.nextButton) {
      const nextIndex = isLast ? 0 : this.currentSlideIndex + 1;
      this.nextButton.setAttribute('aria-label', `Next slide (${nextIndex + 1} of ${this.slides.length})`);
    }
  }

  announceSlide(index) {
    let liveRegion = this.container.querySelector('.expanded-carousel-live-region');

    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.className = 'expanded-carousel-live-region visually-hidden';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      this.container.appendChild(liveRegion);
    }

    liveRegion.textContent = `Slide ${index + 1} of ${this.slides.length}`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.expanded-card-carousel__container');

  carousels.forEach((container) => {
    new ExpandedCardCarousel(container);
  });
});

if (typeof module !== 'undefined' && module.exports) {
  module.exports = ExpandedCardCarousel;
}
